import { RequestService } from "../../../../common/services/RequestService";
import { UPDATE_LANDING_LIST } from "./constants";

export const updateLandingListRequest = async payload => {
  const { orderId } = payload;
  let list = payload.selectedRows.map(item => {
    let obj = {
      person_id: item.person_id,
      route_id: payload.selectedStop
    };
    switch (payload.listAction) {
      case 1: {
        return { ...obj, boarding: true };
      }
      case 2: {
        return { ...obj, disembarking: true };
      }
      case 3: {
        return { ...obj, boarding: false };
      }
      case 4: {
        return { ...obj, disembarking: false };
      }
      default:
        return false;
    }
  });

  const response = await RequestService.put(
    UPDATE_LANDING_LIST.replace("{order_id}", orderId),
    { list }
  );
  return response;
};
